import Color from "./Features/Color/Color";
import Shapes from "./Features/Shapes/Shapes";
import Logo from "./Features/Logo/Logo";
import Tabs from "@/components/common/Tabs/Tabs";
import { BiSticker, BiCategoryAlt } from "react-icons/bi";
import { RiPaletteLine } from "react-icons/ri";
import { MdOutlineCenterFocusStrong } from "react-icons/md";
import { useTranslations } from "next-intl";
import Sticker from "./Features/Sticker/Sticker";
import style from "./QrCustomization.module.scss";
function QrCustomization() {
  const t = useTranslations("Home");
  return <>
      <div className={style.Header}>
        <span className={style.step}>2</span>
        <p className={style.TopTitle}>
          {t.rich("customizationTitle", {
          span: children => <span>{children}</span>
        })}
        </p>
      </div>
      <Tabs cls="qr_customization_tab" defaultActiveKey="Sticker" data-sentry-element="Tabs" data-sentry-source-file="QrCustomization.tsx">
        <Tabs.Tab eventKey="Sticker" title={<div className={style.tabTitle}>
              <BiSticker /> {t("sticker")}
            </div>} data-sentry-element="unknown" data-sentry-source-file="QrCustomization.tsx">
          <Sticker data-sentry-element="Sticker" data-sentry-source-file="QrCustomization.tsx" />
        </Tabs.Tab>
        <Tabs.Tab eventKey="Color" title={<div className={style.tabTitle}>
              <RiPaletteLine size={16} />
              {t("color")}
            </div>} data-sentry-element="unknown" data-sentry-source-file="QrCustomization.tsx">
          <Color data-sentry-element="Color" data-sentry-source-file="QrCustomization.tsx" />
        </Tabs.Tab>
        <Tabs.Tab eventKey="Shapes" title={<div className={style.tabTitle}>
              <BiCategoryAlt size={16} />
              {t("shapes")}
            </div>} data-sentry-element="unknown" data-sentry-source-file="QrCustomization.tsx">
          <Shapes data-sentry-element="Shapes" data-sentry-source-file="QrCustomization.tsx" />
        </Tabs.Tab>
        <Tabs.Tab eventKey="Logo" title={<div className={style.tabTitle}>
              <MdOutlineCenterFocusStrong size={16} />
              {t("logo")}
            </div>} data-sentry-element="unknown" data-sentry-source-file="QrCustomization.tsx">
          <Logo data-sentry-element="Logo" data-sentry-source-file="QrCustomization.tsx" />
        </Tabs.Tab>
      </Tabs>
    </>;
}
export default QrCustomization;